import React from 'react';
import {
    MenuItem,
} from '@mui/material';
import {CustomSelectAndChildren} from "../../../../../components/CustomSelectAndChildren";
import {CustomTextField} from "../../../../../components/CustomTextField";
import {CustomDatePicker} from "../../../../../components/CustomDatePicker";

const ContractFields = ({contract, setContract, emptyFields, isValidStartDate, setIsValidStartDate,
                                isValidEndDate, setIsValidEndDate, getAllContractor,  handleStartDateChange,
                                 handleEndDateChange}) => {

    return (
        <>
            <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6"}>
                <CustomSelectAndChildren id={"slt_cc_choose_contractor"}
                                         name={"chooseContractor"}
                                         trans={"choose_a_contractor"}
                                         onChange={(e) =>
                                             setContract((prevData) => ({
                                                 ...prevData,
                                                 contractorId: e.target.value,
                                             }))
                                         }
                                         value={contract.contractorId}
                                         required={true}
                                         emptyFields={emptyFields}
                                         disabled={!!contract?.id}
                                         showNoSelectionOption={false}
                >

                    {getAllContractor &&
                    getAllContractor.map((item, index) => (
                        <MenuItem value={item?.id} key={index}>
                            {item?.acronym} |  {item?.user?.name}
                        </MenuItem>
                    ))}
                </CustomSelectAndChildren>
            </div>
            <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6"}>
                <CustomTextField trans={'folio'}
                                 id={'txt_cc_folio'}
                                 value={contract.folio}
                                 name={"folio"}
                                 onChange={(e) =>
                                     setContract((prevData) => ({
                                         ...prevData,
                                         folio: e.target.value,
                                     }))
                                 }
                />
            </div>
            <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6"}>
                <CustomDatePicker id={"dp_cc_start_date"}
                                  name={'startDate'}
                                  disabled={false}
                                  onChange={(e) => handleStartDateChange(e)}
                                  trans={"start_contract"}
                                  value={contract.startDate}
                                  required={true}
                                  openTo={"day"}
                                  disablePast={false}
                                  emptyFields={emptyFields}
                                  isValid={isValidStartDate}
                                  onError={(error) => {setIsValidStartDate(error === null)}}

                />
            </div>
            <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6"}>
                <CustomDatePicker id={"dp_cc_end_date"}
                                  name={'endDate'}
                                  disabled={contract.startDate === null}
                                  minDate={contract.startDate}
                                  onChange={(e) => handleEndDateChange(e)}
                                  trans={"end_contract"}
                                  value={contract.endDate}
                                  required={true}
                                  openTo={"day"}
                                  disablePast={false}
                                  emptyFields={emptyFields && contract.startDate !== null}
                                  isValid={isValidEndDate}
                                  onError={(error) => {setIsValidEndDate(error === null)}}

                />
            </div>
            <div className="col-sm-12">
                <CustomTextField id={"slt_cc_description"}
                                 name={"description"}
                                 value={contract.description}
                                 trans={"description"}
                                 type={"text"}
                                 disabled={false}
                                 required={false}
                                 onChange={(e) =>
                                     setContract((prev) => ({
                                         ...prev,
                                         description: e.target.value?.slice(0, 512),
                                     }))
                                 }
                                 multiline={true}
                                 length={512}
                />
            </div>
        </>
    );
};

export default ContractFields;
